import {
  Avatar,
  Box,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import CheckIco from "../../../../assets/icons/CheckIco";
import { StyledFlexRowView } from "../../../common-components/StyledComponents";

const data = {
  progress: 96,
  sections: [
    {
      title: "Type of Agencies to Target:",
      items: [
        "Agencies specializing in Salesforce implementation and management.",
        "Firms with a strong background in cloud solutions and digital transformation.",
        "Agencies with proven experience in the public sector, particularly state or government projects.",
      ],
    },
    {
      title: "Selection Criteria:",
      items: [
        "Proven track record in similar projects.",
        "Strong team capabilities and relevant certifications.",
        "Ability to demonstrate understanding of state government operations and objectives.",
      ],
    },
    {
      title: "Key Deliverables:",
      items: [
        "Project Kick-off Meeting: Establish project scope and timelines.",
        "Requirements Documentation: Detailed specifications of business needs.",
        "Implementation Plan: Comprehensive strategy for development and deployment.",
        "User Training Sessions: Conduct training for end-users on Salesforce functionality.",
        "Testing and QA Reports: Documentation of testing phases and outcomes.",
        "Final Project Report: Overview of project execution, outcomes, and recommendations.",
      ],
    },
    {
      title: "Latest Business Trends:",
      items: [
        "Digital Transformation: Companies are increasingly moving to cloud-based solutions for better collaboration and data accessibility.",
        "Customer-Centric Approach: Emphasis on leveraging CRM systems for enhanced customer engagement and relationship management.",
        "Agile Methodology: Adoption of agile project management practices for iterative development and faster delivery.",
        "Data-Driven Decision Making: Utilizing analytics from CRM systems to inform strategy and operational improvements.",
      ],
    },
  ],
};

function IgniteStrategy() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: { xs: 2 },
        gap: 4,
        // maxWidth: "1200px",
        margin: "auto",
      }}
    >
      {/* Left Section - Circular Gauge */}
      <Box
        sx={{
          flexShrink: 0,
          textAlign: "center",
        }}
      >
        <Box
          position="relative"
          display="inline-flex"
          borderRadius="50%"
          padding="0.7rem"
          border="1px solid #EAECF0"
        >
          <Gauge
            width={184}
            height={184}
            value={data.progress}
            cornerRadius="50%"
            text={({ value }) => `${value}%`}
            sx={{
              [`& .${gaugeClasses.valueText}`]: {
                fontSize: "1.5rem",
                color: "#101828",
                fontWeight: 700,
              },
              [`& .${gaugeClasses.valueArc}`]: {
                fill: "#47CD89",
              },
            }}
          />
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, marginTop: 1 }}>
          Excellent
        </Typography>
      </Box>

      {/* Right Section - Content */}
      <Box
        sx={{
          flexGrow: 1,
          border: "1px solid #EAECF0", // Add border here
          borderRadius: "8px", // Add rounded corners
          backgroundColor: "#FFFFFF", // White background
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.05)", // Optional subtle shadow
          padding: "24px",
        }}
      >
        <StyledFlexRowView>
          <Avatar
            sx={{
              bgcolor: "transparent",
              marginRight: "4px",
              height: "25px !important",
            }}
          >
            {<CheckIco />}
          </Avatar>

          <div>
            <Typography
              variant="h6"
              sx={{
                fontSize: "16px",
                fontWeight: 700,
                color: "#667085",
                marginBottom: 1,
              }}
            >
              {"Strategy Recommendation: "}
            </Typography>
            {data.sections.map((section, index) => (
              <Box key={index} sx={{ marginBottom: 1 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    color: "#667085",
                    // marginBottom: 1,
                  }}
                >
                  {section.title}
                </Typography>
                <List sx={{ paddingLeft: 2 }}>
                  {section.items.map((item, idx) => (
                    <ListItem
                      key={idx}
                      sx={{
                        padding: 0,
                        alignItems: "flex-start",
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          display: "inline-block",
                          width: "4px",
                          height: "4px",
                          backgroundColor: "#667085", // Bullet color
                          borderRadius: "50%",
                          marginTop: "15px",
                          marginRight: "16px", // Space between bullet and text
                          flexShrink: 0,
                        }}
                      />
                      <ListItemText
                        primary={item}
                        primaryTypographyProps={{
                          fontSize: "1rem",
                          color: "#667085",
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            ))}
          </div>
        </StyledFlexRowView>
      </Box>
    </Box>
  );
}

export default IgniteStrategy;
